<template>
  <div id="content">
    <div id="productdetail"
         ref="productdetailref">
      <div id="detail-wrap">
        <div class="product-detail-wrap">

          <div class="panel clearfix">
            <div class="preview-wrap">
              <div class="preview">
                <div class="main-img-wrap">

                  <i class="iconfont icon-guanbi1"
                     style="display: none"></i>
                  <img :src="porduct.images[current_index]">
                </div>
                <div class="preview-gallery">
                  <ul class="preview-list slick-initialized slick-slider"
                      style="display: block;">
                    <div class="slick-list">
                      <div class="slick-track"
                           style="opacity: 1; width: 100%; transform: translate3d(0px, 0px, 0px);">
                        <div class="slick-slide slick-current slick-active"
                             data-slick-index="0"
                             aria-hidden="false">
                          <div style="text-align:left">
                            <li style="width: 94px; display: inline-block;"
                                v-for="(item,index) in porduct.images"
                                :key="item.id">
                              <img v-if="index==current_index"
                                   class="active smallimg"
                                   @click="imgclick(index)"
                                   :src="item">
                              <img v-else
                                   :src="item"
                                   class="smallimg"
                                   @click="imgclick(index)">
                            </li>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ul>
                </div>
              </div>

              <div class="random-scrolling-wrap"
                   style="display:none;"></div>
            </div>
            <div class="item-info-wrap">
              <div class="item-info">
                <div>
                  <div class="util-font-18 font-weight-bold util-m-b util-line-24">
                    <span class="title"
                          v-if="$i18n.locale=='en'">
                      {{porduct.prod_enname}}
                    </span>
                    <span class="title"
                          v-else>
                      {{porduct.prod_name}}
                    </span>
                  </div>
                  <!-- 分享跟收藏-->

                </div>
                <div class="price-info-wrap">
                  <div class="price-info-wrap-box">

                    <div class="price-info-wrap-box-item">
                      <span class="margin-left-10 util-line-s util-v-m inline-block"
                            style="height:22px;">
                        <span>
                          <span>

                          </span>
                        </span>

                      </span>
                      <p class="price-info-wrap-box-code">
                        {{porduct.prod_numbers}}
                      </p>
                    </div>

                  </div>

                </div>

                <div class="cart-handle-wrap">

                  <div class="add-cart-wrap col-xs-12">
                    <div class="flex-box">
                      <div class="col-xs-12">

                        <div class="util-v-m">
                          <div class="product-number-handle"
                               v-if="!isLogin">

                            <div class="product-gcIpt">
                              <span class="product-guT">

                                <span id="current_price">**.</span>
                                <span style="font-size: 18px;color: gray;"></span>
                              </span>

                            </div>

                            <div class="product-actions-primary">
                              <a @click="gologin"
                                 title=""> {{ $t("productdetails.gologin")}}</a>
                            </div>

                          </div>
                          <div v-else
                               class="product-number-handle">

                            <div class="product-gcIpt">
                              <span class="product-guT">

                                <span id="current_price">¥{{porduct.prod_price}}</span>
                              </span>

                              <el-input-number v-model="procount"
                                               :min="1"
                                               :max="1000000"></el-input-number>

                            </div>
                            <el-button type="success"
                                       @click="addCart()"
                                       icon="el-icon-shopping-cart-2">{{ $t("productdetails.jrgwc")}}</el-button>
                            <!-- 
                            <div class="product-actions-primary">
                              <a href="#"
                                 id="gg_addcart"
                                 onclick="addtocart(2542637)"
                                 title=""
                                 data-original-title="Add to Cart"> <i class="fa fa-cart-plus"
                                   aria-hidden="true"></i>&nbsp;&nbsp;加入购物车</a> 
                          </div>-->

                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="product-attribute">

                    <div class="product-attribute-item">
                      <p>{{ $t("productdetails.cpzl")}}</p>
                      <p class="productdetaillabel"
                         v-if="$i18n.locale=='en'">
                        {{porduct.smallclassid_name_en}}
                      </p>
                      <p class="productdetaillabel"
                         v-else>
                        {{porduct.smallclassid_name}}
                      </p>

                    </div>

                    <div class="product-attribute-item">

                      <p>{{ $t("productdetails.cpbz")}}
                        <!-- <el-badge class="item"
                                  :value="porduct.package_type" /> -->
                      </p>
                      <p class="productdetaillabel"
                         v-if="$i18n.locale=='en'">

                        {{porduct.package_name_en}}

                      </p>
                      <p class="productdetaillabel"
                         v-else>

                        {{porduct.package_name}}

                      </p>
                      <el-popover placement="bottom"
                                  trigger="hover">
                        <div>
                          <img v-if="porduct.package_type"
                               :src="require('../images/package_'+porduct.package_type+'.jpg')">
                        </div>
                        <el-button slot="reference"
                                   style="border:none;border-width:0px;padding: 0px;">
                          <el-badge class="item"
                                    :value="porduct.package_type" />
                        </el-button>
                      </el-popover>
                    </div>
                    <div class="product-attribute-item">
                      <p>{{ $t("productdetails.wxsl")}}</p>
                      <p class="productdetaillabel">{{porduct.prod_packing}}</p>
                    </div>
                    <div class="product-attribute-item pdlwhdiv">
                      <p>{{ $t("productdetails.lwh")}}&nbsp;<span style="background-color:#FFC0CB;"
                              class="badge badge-info">
                        </span></p>
                      <p class="productdetaillabel">{{porduct.prod_productL}} * {{porduct.prod_productW}} * {{porduct.prod_productH}}</p>
                    </div>
                    <div class="product-attribute-item">
                      <p>{{ $t("productdetails.outlwh")}}</p>
                      <p class="productdetaillabel">{{porduct.prod_outerBoxL}} * {{porduct.prod_outerBoxW}} * {{porduct.prod_outerBoxH}}</p>
                    </div>

                    <div class="product-attribute-item">
                      <p>{{ $t("productdetails.cprq")}}</p>
                      <p class="productdetaillabel">{{porduct.prod_date|formatDate}}</p>
                    </div>

                    <div class="product-attribute-item">
                      <p>{{ $t("productdetails.nhgs")}}</p>
                      <p class="productdetaillabel"> {{porduct.prod_innerBox}}</p>
                    </div>

                    <div class="product-attribute-item">
                      <p>{{ $t("productdetails.tj")}}</p>
                      <p class="productdetaillabel">{{(porduct.prod_outerBoxL*porduct.prod_outerBoxW*porduct.prod_outerBoxH* 0.000001)|numFilter}}</p>
                    </div>
                    <div class="product-attribute-item">
                      <p>{{ $t("productdetails.mj")}}</p>
                      <p class="productdetaillabel"> {{porduct.prod_GW}}/ {{porduct.prod_NW}}</p>
                    </div>

                    <div v-if="isLogin"
                         class="product-attribute-item">
                      <p>{{ $t("productdetails.cjbh")}}</p>
                      <p class="productdetaillabel">{{porduct.prod_item}}</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="panel padding-0">
            <div class="description">
              <ul id="description-tab"
                  class="tab clearfix">
                <li><a class="active item">{{ $t("productdetails.spms")}}</a></li>

                <span></span>
              </ul>
              <div id="description-desc">
                <div style="background:#f4f4f4;padding-bottom:15px;">
                  <div class="panel"
                       style="margin-top:0;">
                    <div class="base-info util-font-14"
                         style="min-height:220px;">
                      <div>
                        <div class="title">
                          <div class="sub-title">{{ $t("productdetails.jcxj")}}</div>
                          <div>
                            <div class="padding-top-10 padding-bottom-10 special-attr clearfix">
                              <li>
                                <span class="color-little-gray">
                                  <span>{{ $t("productdetails.cphh")}} </span>
                                </span>
                                <span>{{porduct.prod_numbers}}</span>
                              </li>
                              <li v-if="isLogin">
                                <span class="color-little-gray">
                                  <span>{{ $t("productdetails.cjbh")}} </span>
                                </span>
                                <span>{{porduct.prod_item}}</span>
                              </li>
                              <li>
                                <span class="color-little-gray">
                                  <span>{{ $t("productdetails.cpmc")}} </span>
                                </span>
                                <span v-if="$i18n.locale=='en'">

                                  {{porduct.prod_enname}}

                                </span>
                                <span v-else>

                                  {{porduct.prod_name}}

                                </span>
                              </li>
                              <li>
                                <span class="color-little-gray">
                                  <span>{{ $t("productdetails.cpzl")}} </span>
                                </span>
                                <span>
                                  <span v-if="$i18n.locale=='en'">

                                    {{porduct.smallclassid_name_en}}

                                  </span>
                                  <span v-else>

                                    {{porduct.smallclassid_name}}

                                  </span>
                                </span>
                              </li>
                              <li>
                                <span class="color-little-gray">
                                  <span>{{ $t("productdetails.cprq")}} </span>
                                </span>
                                <span>
                                  <span>{{porduct.prod_date|formatDate}}</span>
                                </span>
                              </li>

                              <!-- <li>
                                <span class="color-little-gray">
                                  <span>证书类型</span>
                                  <span>：</span>
                                </span>
                                <span>
                                  <span>10P ILAC,EN71 ILAC</span>
                                </span>
                              </li> -->

                            </div>
                          </div>
                          <div class="margin-top-10">
                            <div class="title">
                              <div class="sub-title"> {{ $t("productdetails.ccbz")}} </div>
                            </div>
                            <div class="padding-top-10 padding-bottom-10 special-attr clearfix">
                              <li>
                                <span class="color-little-gray">
                                  <span> {{ $t("productdetails.cpbz")}} </span>
                                </span>
                                <span v-if="$i18n.locale=='en'">

                                  {{porduct.package_name_en}}

                                </span>
                                <span v-else>

                                  {{porduct.package_name}}

                                </span>
                              </li>

                              <li>
                                <span class="color-little-gray">
                                  <span>{{ $t("productdetails.wxsl")}} </span>
                                </span>
                                <span>
                                  {{porduct.prod_packing}}
                                </span>
                              </li>
                              <li>
                                <span class="color-little-gray">
                                  <span>{{ $t("productdetails.nhgs")}} </span>
                                </span>
                                <span>{{porduct.prod_innerBox}}</span>
                              </li>
                              <li>
                                <span class="color-little-gray">
                                  <span>{{ $t("productdetails.mj")}} </span>
                                </span>
                                <span>{{porduct.prod_GW}}/ {{porduct.prod_NW}}</span>
                              </li>
                              <li>
                                <span class="color-little-gray pdlwhdiv">
                                  <span>{{ $t("productdetails.lwh")}} <i style="color:green;"
                                       class="fa fa-question-circle-o"
                                       aria-hidden="true"></i></span>
                                </span>
                                <span>
                                  <span>{{porduct.prod_productL}}</span>
                                  <span>&nbsp;×&nbsp;</span>
                                  <span> {{porduct.prod_productW}}</span>
                                  <span>&nbsp;×&nbsp;</span>
                                  <span> {{porduct.prod_productH}}</span>
                                </span>
                              </li>
                              <li>
                                <span class="color-little-gray">
                                  <span>{{ $t("productdetails.outlwh")}}</span>
                                </span>
                                <span> <span>{{porduct.prod_outerBoxL}}</span>
                                  <span>&nbsp;×&nbsp;</span>
                                  <span>{{porduct.prod_outerBoxW}}</span>
                                  <span>&nbsp;×&nbsp;</span>
                                  <span> {{porduct.prod_outerBoxH}}</span>
                                </span>
                              </li>
                              <li>
                                <span class="color-little-gray">
                                  <span>{{ $t("productdetails.tj")}}</span>
                                </span>
                                <span>{{(porduct.prod_outerBoxL*porduct.prod_outerBoxW*porduct.prod_outerBoxH* 0.000001)|numFilter}}</span>
                              </li>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="desc">
                      <div class="attr-content">

                        <div class="image">
                          <div class="info"
                               style="display: block">
                            <a name="productvideo"
                               id="productvideo"></a>
                            <div ref="selector1"
                                 id="selector1"
                                 v-if="porduct.prod_video!=null&&porduct.prod_video!=''"><iframe height="680"
                                      :src="porduct.prod_video"
                                      frameborder="0"
                                      width="100%"
                                      allowfullscreen=""></iframe>
                            </div>
                            <div key="1">
                              <img class="lazy"
                                   onerror="imgError(this, 'p-sm')"
                                   :src="porduct.images[current_index]"
                                   style="display: block;">
                            </div>

                          </div>
                          <ul class="tab clearfix">
                            <li><a class="active item">{{ $t("productdetails.ccclfs")}} </a></li>

                            <span></span>
                          </ul>
                          <img src="../images/package_all.jpg"
                               style="display: block;">
                        </div>
                      </div>
                      <div class="inquiry"></div>
                    </div>
                  </div>

                </div>
              </div>

              <div class="panel">
                <div class="recommend">
                  <h4 class="title">{{ $t("productdetails.tccp")}} </h4>
                  <div class="product">
                    <ul>
                      <li v-for="p in products"
                          :key="p.id"
                          style="display:block;text-align:left">
                        <a :href="'/#/productdetail/'+p.ID"
                           target="_blank"><img :src="p.prod_image"
                               width="260px"
                               height="195px"
                               alt="" /></a>
                        <a v-if="$i18n.locale=='en'"
                           :href="'/#/productdetail/'+p.ID"
                           target="_blank">
                          <div style="width:100%;height: 33px;"><span>{{p.prod_numbers}}</span>
                            <span style="float:right;text-align:right">{{p.prod_productL}}*{{p.prod_productW}}*{{p.prod_productH}}</span>
                          </div>
                          <div style="width:100%;height: 33px;margin-left: 0px;padding-left: 0px;text-align: left;"><span>{{p.prod_enname}}</span></div>
                        </a>
                        <a v-else
                           :href="'/#/productdetail/'+p.ID"
                           target="_blank">
                          <div style="width:100%;height: 33px;"><span class="le">{{p.prod_numbers}}</span>
                            <span style="float:right;text-align:right">{{p.prod_productL}}*{{p.prod_productW}}*{{p.prod_productH}}</span>
                          </div>
                          <div style="width:100%;height: 33px;margin-left: 0px;padding-left: 0px;"><span class="le">{{p.prod_name}}</span></div>
                        </a>
                      </li>
                    </ul>
                    <!-- <div class="product-items-wrap undefined">

                      <li class="itemwrap">
                        <div class="normal">
                          <a href="/product/detail_2110235.html"
                             class="pic">
                            <img class="lazy"
                                 style="display: inline;">
                          </a>

                          <div class="info no-login">
                            <div class="pdName"
                                 style="height:36px;display:normal;">
                              <a href="/product/detail_2110235.html">MKL815180

                                窗盒16寸四声IC会喝水尿尿男娃配推车坐便器餐具

                              </a>
                            </div>

                          </div>
                        </div>
                      </li>

                    </div> -->
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <!-- <div class="nav_prod"
           v-if="$i18n.locale == 'en'">
        Position: <a href="/#/product"><span>Product</span></a> > <a :href="'/#/product/' + porduct.bigclassid"><span>{{porduct.bigclassid_name_en}}</span></a> > <span>{{porduct.prod_enname}}</span>
      </div>
      <div class="nav_prod"
           v-else>
        你当前的位置：<a href="/#/product"><span>产品展示</span></a> > <a :href="'/#/product/' + porduct.bigclassid"><span>{{porduct.bigclassid_name}}</span></a> > <span>{{porduct.prod_name}}</span>

      </div>

      <div class="product_1">
        <div class="product_101"
             v-if="$i18n.locale == 'en'">
          {{ porduct.prod_enname }}
        </div>
        <div v-else
             class="product_101">{{ porduct.prod_name }}</div>
        <div class="prod le">
          <div class="tempWrap">
            <ul>
              <li v-for="p in porduct.images"
                  :key="p"
                  style="height: 750px">
                <img :src="p" />
              </li>
            </ul>
          </div>
        </div>
        <div class="hd fr">
          <ul>
            <li v-for="p in porduct.images"
                :key="p">
              <img :src="p" />
            </li>
          </ul>
        </div>
        <div class="clear"></div>
      </div>
      <div class="product_102">
        <div v-if="$i18n.locale == 'en'"
             class="product_103 le">PROD INFO：</div>
        <div v-else
             class="product_103 le">产品详情</div>
        <span v-if="$i18n.locale == 'en'">NO：{{porduct.prod_numbers}}</span>
        <span v-else>商品货号：{{porduct.prod_numbers}}</span>
        <br />
        <span v-if="$i18n.locale == 'en'">NAME：{{porduct.prod_enname}}</span>
        <span v-else>商品品名：{{porduct.prod_name}}</span>
        <br />
        <span v-if="$i18n.locale == 'en'">COLOR：{{porduct.prod_color_en}}</span>
        <span v-else>颜色选择：{{porduct.prod_color}}</span>
        <br />
        <span v-if="$i18n.locale == 'en'">STYLE：{{porduct.prod_style_en}}</span>
        <span v-else>款式选择：{{porduct.prod_style}}</span>
        <br />
        <span v-if="$i18n.locale == 'en'">MADE：{{porduct.prod_made_en}}</span>
        <span v-else>商品产地：{{porduct.prod_made}}</span>
        <br />
        <span v-if="$i18n.locale == 'en'">MATERIAL{{porduct.prod_material_en}}</span>
        <span v-else>商品材质：{{porduct.prod_material}}</span>
        <br />
        <span v-if="$i18n.locale == 'en'">AGE：{{porduct.prod_age_en}}</span>
        <span v-else>适用年龄：{{porduct.prod_age}}</span>
        <br />
        <span v-if="$i18n.locale == 'en'">BOX SIZE：{{porduct.prod_box_en}}</span>
        <span v-else>外箱规格：{{porduct.prod_box}}</span>
        <br />
        <span v-if="$i18n.locale == 'en'">SIZE：：{{porduct.prod_inner_en}}</span>
        <span v-else>产品规格：{{porduct.prod_inner}}</span>
        <br />
        <span v-if="$i18n.locale == 'en'">COUNT：{{porduct.prod_box_num_en}}</span>
        <span v-else>装箱数量：{{porduct.prod_box_num}}</span>
        <br />
        <span v-if="$i18n.locale == 'en'">CONFIG：{{porduct.prod_info_en}}</span>
        <span v-else>产品配置：{{porduct.prod_info}}</span>
        <br />
      </div>
      <div v-if="$i18n.locale == 'en'"
           class="product_104"
           v-html="porduct.prod_content_en">
      </div>
      <div v-else
           class="product_104"
           v-html="porduct.prod_content">
      </div>-->
    </div>
  </div>
</template>

<script>
import fetch from "@/utils/axios";
import { formatDate } from '@/utils/formatDate'
export default {
  components: {},
  name: "ProductDetail",
  data () {
    return {
      porduct: {},
      current_image: null,
      current_index: 0,
      isLogin: localStorage.getItem('isLogin') == 'true',
      procount: 1,
      products: []
    };
  },
  methods: {
    imgclick (index) {
      this.current_index = index
    },
    gologin () {
      this.$emit('gologininfo', {})
    },
    addCart () {
      const params = { prod_id: this.porduct.ID, count: this.procount }; // 参数
      fetch.post("/api/ApiBuyInfo/AddProductBuy", params).then(
        (res) => {
          this.$message({
            message: '操作成功！',
            type: 'success'
          });
        },
        (error) => {
          this.$message({
            message: JSON.stringify(error),
            type: 'error'
          });
          alert(JSON.stringify(error));
        }
      );
    }
  },
  filters: {
    //方法一
    formatDate (val) {
      return formatDate(val);
    },
    numFilter (val) {
      return parseFloat(val).toFixed(2)
    }
  },
  mounted () {
    // 使用
    const params = { id: this.$route.params.id }; // 参数
    fetch.post("/api/ApiProduct/Get", params).then(
      (res) => {
        this.porduct = res;
        if (this.porduct.prod_video != null && this.porduct.prod_video != '' && this.porduct.prod_video.indexOf('v.qq.com') == -1) {
          this.porduct.prod_video = 'https://v.qq.com/txp/iframe/player.html?vid=' + this.porduct.prod_video;
        }
        this.current_image = this.porduct.prod_image;
        if (this.porduct.prod_ma_nu != null && this.porduct.prod_ma_nu != '') {
          const sparams = { ma_nu: this.porduct.prod_ma_nu }; // 参数
          fetch.post("/api/ApiProduct/GetAllProductList", sparams).then(
            (ress) => {
              this.products = ress;
            },
            (error) => {
              alert(JSON.stringify(error));
            }
          );
        }
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
    var hash = window.location.hash;
    var index = hash.lastIndexOf("#");
    if (index != -1) {


      setTimeout(() => {//页面没有渲染完成时是无法滚动的，因此设置延迟

        var id = hash.substring(index + 1, hash.length + 1);
        //alert(this.$refs.selector1)
        var anchor = document.querySelector('#' + id);//获取元素

        console.info("anchor", anchor)
        //anchor.scrollIntoView(); //js的内置方法，可滚动视图位置至元素位置

        if (anchor) {
          var targetOffset = $(anchor).offset().top - 180;

          console.info("targetOffset", anchor, targetOffset)

          $('html,body').animate({

            scrollTop: targetOffset

          },

            1000);

        }
      }, 500);

    }
  },
};
</script>

<style>
#productdetail {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 1240px;
  margin: 5px auto auto;
  text-align: left;
}
.product_1 {
  width: 1400px;
  margin: 20px auto auto;
}
.product_101 {
  width: 100%;
  text-align: center;
  color: #333;
  font-size: 26px;
  line-height: 32px;
  margin-bottom: 20px;
}

.prod {
  width: 1000px;
  border: 1px #f5f5f5 solid;
  height: 750px;
  margin-left: 40px;
}
.prod li {
  width: 1000px;
}
.prod li img {
  display: block;
  overflow: hidden;
  width: 1000px;
  height: 750px !important;
}
.product_1 .hd {
  width: 350px;
}
.product_1 .hd li {
  text-align: right;
  margin-bottom: 10px;
  width: 314px;
  height: 225px;
  overflow: hidden;
}
.product_1 .hd li img {
  width: 300px;
  height: 223px;
  border: 1px #f5f5f5 solid;
}
.product_1 .hd li:hover {
  /* background: url(../images/prod01.jpg) no-repeat left center; */
}
.product_1 .hd li:hover img {
  border: 1px #01a4e9 solid;
}
.product_1 .hd li.on {
  /* background: url(../images/prod01.jpg) no-repeat left center; */
}
.product_1 .hd li.on img {
  border: 1px #01a4e9 solid;
}

.product_102 {
  text-align: left;
  width: 1320px;
  margin: 20px auto auto;
  font-size: 18px;
  color: #666;
  line-height: 30px;
  height: auto !important;
  min-height: 200px;
  _height: 200px;
}
.product_103 {
  width: 1320px;
  margin-bottom: 20px;
  font-weight: bold;
  margin: 20px auto auto;
}

.product_104 {
  width: 1320px;
  margin: 30px auto auto;
  padding-top: 18px;
  border-top: 1px #ccc dashed;
}
.nav_prod {
  display: block;
  font-size: 14px;
  color: #333;
  width: 1300px;
  height: 32px;
  text-align: left;
  line-height: 32px;
  background: #e6e6e6;
  border-bottom: 3px #dbdbdb solid;
  margin: 30px auto auto;
  padding-left: 30px;
}
.compareWrapper .c-action .btn,
.compareWrapper .c-product .title,
.product-detail-wrap .brand-new-wrap .brand-new-item-right-value,
.product-detail-wrap .product-brand-info .brand-name em {
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
}

.compareWrapper {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 100;
  width: 100%;
}

.product {
  width: 1190px;
  overflow: hidden;
  margin: 5px auto auto;
}
.product ul {
  width: 1190px;
}
.product li {
  float: left;
  width: 262px;
  height: 248px;
  display: inline-block;
  padding: 9px;
  background: #f5f5f5;
  /* margin-top: 25px; */
  margin-right: 17px;
}
.product li img {
  display: block;
  border: 0;
  width: 262px;
  height: 176px;
  overflow: hidden;
}
.product li span {
  text-align: left;
  height: 33px;
  line-height: 33px;
  font-size: 14px;
  color: #333;
  overflow: hidden;
}
.product li em {
  display: block;
  text-align: right;
  font-style: normal;
  font-size: 12px;
  line-height: 24px;
}
.product li em a {
  color: #999;
}
.product li:hover {
  background: #00a0e9;
}
.product li:hover span {
  color: #fff;
}
.product li:hover em a {
  color: #fff;
}
.compareWrapper .compare {
  background: rgba(0, 0, 0, 0.6);
}

.compareWrapper .c-product {
  display: inline-block;
  padding: 9px 0 9px 10px;
}

.compareWrapper .c-product.c-p-5 .item {
  width: 170px;
}

.compareWrapper .c-product .item {
  display: inline-block;
  padding: 10px 30px 10px 60px;
  margin-right: 10px;
  width: 216px;
  line-height: 1;
  background: #fff;
  border: 1px solid #fff;
  border-radius: 2px;
}

.compareWrapper .c-product .item .icon-close-simple,
.compareWrapper .c-product .item .title,
.compareWrapper .c-product .item img {
  height: 40px;
  line-height: 40px;
}

.compareWrapper .c-product .item img {
  float: left;
  margin-left: -50px;
  vertical-align: middle;
}

.compareWrapper .c-product .item .title {
  padding-top: 5px;
  line-height: 1.4;
  height: 38px;
  overflow: hidden;
}

.compareWrapper .c-product .item .icon-close-simple {
  float: right;
  margin-right: -25px;
  width: 18px;
  text-align: center;
  color: #9f9f9f;
  font-size: 20px;
}

.compareWrapper .c-product .title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-word;
  color: #222;
}

.compareWrapper .c-product .empty {
  padding: 20px 0 0 20px;
  color: #fff;
  font-size: 14px;
}

.compareWrapper .c-action {
  float: right;
  height: 80px;
  line-height: 80px;
}

.compareWrapper .c-action .btn {
  float: right;
  margin-top: 24px;
  border-radius: 2px;
  vertical-align: middle;
  max-width: 130px;
}

.compareWrapper .c-action .btn-link {
  float: right;
  color: #fff;
}

.compareWrapper .c-action .icon-cycle-close {
  float: right;
  padding: 0 20px;
  line-height: 80px;
  color: #fff;
  background: rgba(0, 0, 0, 0.4);
  font-size: 22px;
}

.la-ru .compareWrapper .c-action .icon-cycle-close {
  padding: 0 9px;
}

.la-ru .compareWrapper .c-action .btn-link {
  padding-right: 10px !important;
}

.la-ru .compareWrapper .c-action .btn {
  max-width: 164px;
}

.product-detail-wrap {
  position: relative;
}

.product-detail-wrap .util-m-b {
  margin-bottom: 10px;
}

.product-detail-wrap .btn-join {
  border: 0;
  margin-left: 10px;
  vertical-align: middle;
  font-size: 16px;
  line-height: 1.5;
  padding: 11px 10px;
  border-radius: 4px;
  min-width: 174px;
  background: -o-linear-gradient(177.47deg, #1477ff 2.87%, #57aeff 97.2%);
  background: linear-gradient(272.53deg, #1477ff 2.87%, #57aeff 97.2%);
}

.product-detail-wrap .btn-join .iconfont {
  font-size: 16px;
}

.product-detail-wrap .btn-join .txt {
  height: 17px;
  line-height: 17px;
  display: inline-block;
  vertical-align: middle;
}

.product-detail-wrap .panel {
  padding: 20px;
  margin-top: 15px;
  background: #fff;
}

.product-detail-wrap .panel.padding-0 {
  padding: 0;
}

.product-detail-wrap .panel:first-child {
  margin-top: 0;
  padding: 20px;
}

.product-detail-wrap .preview-wrap {
  float: left;
  margin-right: 20px;
  position: relative;
}

.product-detail-wrap .preview .main-img-wrap {
  position: relative;
  width: 620px;
  /* height: 500px;*/
  overflow: hidden;
}

.product-detail-wrap .preview .main-img-wrap img {
  width: 600px;
  /* height: 430px*/
}

.product-detail-wrap .preview .main-img-wrap video {
  position: absolute;
  top: 0;
  z-index: 9;
  background: #000;
}

.product-detail-wrap .preview .main-img-wrap .video-svg {
  position: absolute;
  bottom: -20px;
  left: 20px;
  z-index: 10;
  width: 50px;
  cursor: pointer;
}

.product-detail-wrap .preview .main-img-wrap .icon-guanbi1 {
  position: absolute;
  top: 0;
  right: 10px;
  z-index: 10;
  font-size: 40px;
  color: #fff;
  opacity: 0.5;
  cursor: pointer;
}

.product-detail-wrap .item-info .price-info-wrap .icon-tran-black-d,
.product-detail-wrap .preview .preview-gallery .icon-next {
  right: 0;
}

.product-detail-wrap .preview .main-img-wrap .icon-guanbi1:hover {
  opacity: 1;
}

.product-detail-wrap .preview .preview-gallery {
  position: relative;
  height: 100px;
  padding: 10px 10px 0;
  width: 500px;
}

.product-detail-wrap .preview .preview-gallery .icon {
  position: absolute;
  top: 35px;
  opacity: 0.5;
}

.product-detail-wrap .preview .preview-gallery .icon-prev {
  left: 0;
}

.product-detail-wrap .preview .preview-gallery .slick-arrow :hover {
  opacity: 1;
}

.product-detail-wrap .preview .preview-gallery .slick-hidden {
  display: block;
  opacity: 0.7 !important;
  cursor: default;
}

.product-detail-wrap .preview .preview-list {
  display: none;
}

.product-detail-wrap .preview .preview-list img {
  width: 80px;
  height: 80px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
}

.product-detail-wrap .preview .preview-list img.active {
  border: 1px solid #1477ff;
}

.product-detail-wrap .operation-btn a,
.product-detail-wrap .operation-btn a:link {
  color: #00b2ff;
  font-size: 14px;
  line-height: 22px;
}

.product-detail-wrap .operation-btn .btn-link.disabled {
  cursor: no-drop;
}

.product-detail-wrap .operation-btn .iconfont {
  font-size: 14px;
  margin-right: 5px;
}

.product-detail-wrap .operation-btn .share-btn img {
  width: 20px;
  vertical-align: middle;
}

.product-detail-wrap .operation-btn .icon-xin {
  font-size: 17px;
}

.product-detail-wrap .random-scrolling-wrap {
  position: absolute;
  left: 3px;
  top: 0;
  height: 140px;
  overflow: hidden;
}

.product-detail-wrap .random-txt-list.hide-len0 .random-txt-item:nth-child(2) {
  opacity: 0.9;
}

.product-detail-wrap .random-txt-list.hide-len0 .random-txt-item:nth-child(3) {
  opacity: 0.5;
}

.product-detail-wrap .random-txt-list.hide-len1 .random-txt-item:nth-child(3) {
  opacity: 0.9;
}

.product-detail-wrap .random-txt-item {
  background: #fff;
  -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.07);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.07);
  border-radius: 4px;
  color: #646a73;
  font-size: 14px;
  padding: 8px;
  line-height: 1;
  margin-bottom: 20px;
}

.product-detail-wrap .item-info-wrap {
  float: left;
  width: 530px;
  min-height: 420px;
}

.product-detail-wrap .item-info .title {
  color: #1f2329;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
}

.product-detail-wrap .item-info .product-activity-title {
  background: #1477ff;
  color: #fff;
  font-size: 14px;
  line-height: 32px;
  font-weight: 700;
  padding: 0 12px;
}

.product-detail-wrap .item-info .product-activity-content {
  color: #1477ff;
  font-size: 12px;
  line-height: 18px;
  padding: 0 12px;
}

.product-detail-wrap .item-info .love-num {
  font-size: 13px;
  line-height: 13px;
  color: #939aa3;
}

.product-detail-wrap .item-info .bargain .ask-price {
  color: #00b2ff;
}

.product-detail-wrap .item-info .bargain-price-wrap {
  /* background: url(../picture/82bd16ea-a47b-4136-a8b7-6056177c6729.png) no-repeat; */
  background-size: 100% 100%;
  padding: 24px 12px 16px;
  margin-bottom: 8px;
}

.product-detail-wrap .item-info .bargain-price-wrap .util-m-b {
  margin-bottom: 12px;
}

.product-detail-wrap .item-info .price-info-wrap {
  background: #f5f6f7;
  border-radius: 3px;
  padding: 5px 5px;
  table-layout: fixed;
}

.product-detail-wrap .item-info .price-info-wrap .price-info-wrap-box {
  height: auto;
  background: #f5f3ef;
}

.product-detail-wrap
  .item-info
  .price-info-wrap
  .price-info-wrap-box
  .price-info-wrap-box-price-title {
  font-size: 14px;
  color: #666a6eab;
  margin-top: 10px;
  margin-left: 10px;
  float: left;
  font-weight: 600;
  width: 60px;
  text-align: right;
}

.product-detail-wrap
  .item-info
  .price-info-wrap
  .price-info-wrap-box
  .price-info-wrap-box-code-title {
  font-size: 14px;
  color: #666a6eab;

  line-height: 10px;
  float: left;
  font-weight: 600;
  width: 72px;
  text-align: right;
}

.product-detail-wrap
  .item-info
  .price-info-wrap
  .price-info-wrap-box
  .price-info-wrap-box-attribute-title {
  font-size: 14px;
  color: #666a6eab;
  margin-left: 10px;
  line-height: 20px;
  float: left;
  font-weight: 600;
  width: 60px;
  text-align: right;
}

.product-detail-wrap
  .item-info
  .price-info-wrap
  .price-info-wrap-box
  .price-info-wrap-box-price {
  float: left;
  color: #d7282d;
  margin-left: 20px;
  margin-top: 4px;
}

.product-detail-wrap
  .item-info
  .price-info-wrap
  .price-info-wrap-box
  .price-info-wrap-box-price
  span {
  font-size: 33px;
  color: #cd2426;
}

.product-detail-wrap
  .item-info
  .price-info-wrap
  .price-info-wrap-box
  .price-info-wrap-box-item {
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.product-detail-wrap
  .item-info
  .price-info-wrap
  .price-info-wrap-box
  .price-info-wrap-box-item
  .price-info-wrap-box-code {
  font-size: 20px;
  line-height: 20px;
  font-weight: 600;
  color: #ff6600;
  margin: 5px;
  padding: 10px;
}

.productdetaillabel {
  font-size: 16px;
  line-height: 20px;
  color: #2f2f2f;
}

.product-detail-wrap
  .item-info
  .price-info-wrap
  .price-info-wrap-box
  .price-info-wrap-box-item
  .price-info-wrap-box-attribute {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  font-size: 12px;
  color: #6e7372;
  margin-left: 20px;
  float: left;
}

.product-detail-wrap
  .item-info
  .price-info-wrap
  .price-info-wrap-box
  .price-info-wrap-box-item
  .price-info-wrap-box-attribute
  .product-view-more {
  width: 100%;
  margin-right: 5px;
  display: flex;
  align-items: center;
  position: relative;

  /*  flex: 0 0 46.888%;*/
}

.product-detail-wrap .item-info .cart-handle-wrap {
  font-size: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.product-detail-wrap .item-info .cart-handle-wrap .product-number-handle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.product-detail-wrap
  .item-info
  .cart-handle-wrap
  .product-number-handle
  .product-gcIpt {
  height: 66px;
}

.product-detail-wrap
  .item-info
  .cart-handle-wrap
  .product-number-handle
  .product-gcIpt
  input {
  border: #e3e3e3 solid 1px;
  padding: 5px 8px;
  color: #848484;
  font-size: 16px;
}

.product-detail-wrap
  .item-info
  .cart-handle-wrap
  .product-number-handle
  .product-gcIpt
  .product-guT {
  color: #848484;
  font-size: 30px;
  padding-right: 18px;
  line-height: 63px;
  color: red;
}

.product-detail-wrap
  .item-info
  .cart-handle-wrap
  .product-number-handle
  .product-gcIpt
  #product_amount {
  width: 60px;
  text-align: center;
  color: #0f0f0f;
}

.product-detail-wrap
  .item-info
  .cart-handle-wrap
  .product-number-handle
  .product-gcIpt
  .product-Hgt {
  color: #424242;
  font-size: 14px;
  padding-left: 10px;
}

.product-detail-wrap
  .item-info
  .cart-handle-wrap
  .product-number-handle
  .product-actions-primary
  > a {
  border: 1px solid #cbcbcb;
  border-radius: 3px;

  height: 40px;
  line-height: 40px;
  position: relative;
  text-align: center;
  -webkit-transition: all 400ms ease-in 0s;
  -ms-transition: all 400ms ease-in 0s;
  -transition: all 400ms ease-in 0s;
  transition: all 400ms ease-in 0s;
  width: 100%;
  margin: 0 0 10px;
  font-weight: 700;
  display: block;
  font-family: "Lato", sans-serif;
  font-weight: 700;
  font-size: 15px;
  transform: scale(1);
  margin-bottom: 0;
  margin-right: 35px;
  width: 141px;
  background: #f0ad4e;
  color: #fff;
}

.product-detail-wrap
  .item-info
  .cart-handle-wrap
  .product-number-handle
  .product-actions-primary
  a:hover {
  background: #f0ad4e;
  color: #fff;
  border-color: #f0ad4e;
}
.product-detail-wrap .item-info .cart-handle-wrap .product-attribute {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  width: 100%;
  padding: 5px 5px 5px 15px;
}
.product-detail-wrap .item-info .cart-handle-wrap .product-attribute-item {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex: 0 0 50%;
}

.product-detail-wrap .item-info .price-info-wrap table {
  width: 100%;
  table-layout: fixed;
}

.product-detail-wrap .item-info .price-info-wrap table td {
  padding: 4px 12px;
  border-right: 1px solid #ebebeb;
}

.product-detail-wrap .item-info .price-info-wrap table td:first-child,
.product-detail-wrap .item-info .price-info-wrap table td:last-child {
  border-right: none;
}

.product-detail-wrap .item-info .price-info-wrap .title {
  font-size: 13px;
  line-height: 13px;
  color: #646a73;
}

.product-detail-wrap .item-info .price-info-wrap .price {
  font-size: 18px;
  line-height: 18px;
  color: #1f2329;
}

.product-detail-wrap .item-info .price-info-wrap .price-tip {
  font-size: 15px;
  line-height: 18px;
  color: #646a73;
}

.product-detail-wrap .item-info .price-info-wrap .dropListBox .box {
  border: 0;
  background: 0 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  padding-left: 0;
}

.product-detail-wrap .item-info .add-cart-wrap {
  padding: 2px 0;
}

.product-detail-wrap .item-info .add-cart-wrap .flex-box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.product-detail-wrap .item-info .add-cart-wrap .flex-box .box {
  -ms-flex-item-align: center;
  align-self: center;
}

.product-detail-wrap .item-info .add-cart-wrap .add-cart-tip {
  max-width: 390px;
  font-size: 13px;
  color: #1b75ff;
}

.product-detail-wrap .item-info .add-cart-wrap .add-cart-tip b {
  font-weight: 400;
}

.product-detail-wrap .item-info .add-cart-wrap .count-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.product-detail-wrap .item-info .add-cart-wrap .count-title {
  color: #646a73;
  line-height: 46px;
}

.product-detail-wrap .item-info .add-cart-wrap .count {
  font-size: 13px;
  line-height: 46px;
  text-transform: capitalize;
  color: #939aa3;
}

.product-detail-wrap .item-info .add-cart-wrap .last-price-sign {
  background: rgba(7, 203, 144, 0.08);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 3px;
  font-size: 12px;
  line-height: 12px;
  padding: 4px 6px;
  margin-right: 8px;
  vertical-align: middle;
  color: #07cb90;
}

.product-detail-wrap .item-info .add-cart-wrap .tip {
  font-size: 13px;
  line-height: 14px;
  color: #939aa3;
  vertical-align: middle;
}

.product-detail-wrap .item-info .add-cart-wrap .last-price-wrap {
  margin-right: -380px;
}

.product-detail-wrap .item-info .add-cart-wrap .ask-price {
  font-size: 13px;
  line-height: 35px;
  text-align: right;
  color: #00b2ff;
}

.product-detail-wrap .item-info .sku-info-wrap {
  padding: 15px 0;
  border-top: 1px solid #ebebeb;
}

.product-detail-wrap .item-info .sku-info-wrap ul {
  font-size: 12px;
  line-height: 12px;
}

.product-detail-wrap .item-info .sku-info-wrap li {
  display: block;
  margin-top: 12px;
  color: #939aa3;
}

.product-detail-wrap .item-info .sku-info-wrap li > span {
  vertical-align: middle;
}

.product-detail-wrap .item-info .sku-info-wrap li:first-child {
  margin-top: 0;
}

.product-detail-wrap .item-info .sku-info-wrap .dot {
  background: -o-linear-gradient(177.47deg, #1477ff 2.87%, #57aeff 97.2%);
  background: linear-gradient(272.53deg, #1477ff 2.87%, #57aeff 97.2%);
  border-radius: 4px;
  width: 6px;
  height: 6px;
  display: inline-block;
  margin-right: 12px;
}

.product-detail-wrap .item-info .sku-info-wrap .num {
  font-weight: 700;
}

.product-detail-wrap .item-info .sku-info-wrap .txt {
  color: #1f2329;
}

.product-detail-wrap .item-info .addcart-tip2-wrap {
  position: absolute;
  right: 0;
  bottom: -60px;
  white-space: nowrap;
  -webkit-filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.25));
  filter: drop-shadow(0 0 10px rgba(0, 0, 0, 0.25));
}

.product-detail-wrap .item-info .addcart-tip2-wrap .wrap {
  padding: 12px 15px;
  background: #fff;
  border-radius: 4px;
  font-size: 16px;
  color: #00b2ff;
}

.product-detail-wrap .item-info .addcart-tip2-wrap .iconfont {
  color: #939aa3;
  font-size: 22px;
  margin-left: 10px;
  vertical-align: middle;
}

.product-detail-wrap .item-info .addcart-tip2-wrap .triangle {
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-bottom-color: #fff;
  position: absolute;
  top: -16px;
  right: 50px;
}

.product-detail-wrap .item-info .count-price-wrap .count-price-titile {
  font-size: 14px;
  line-height: 22px;
  color: #939aa3;
}

.product-detail-wrap .item-info .count-price-wrap .line {
  font-size: 12px;
  margin: 0 10px;
  border-left: 1px solid #646a73;
  vertical-align: top;
}

.product-detail-wrap .item-info .count-price-wrap .count-price {
  font-size: 16px;
  line-height: 24px;
  color: #646a73;
}

.product-detail-wrap .item-info .priceTip {
  color: #1f2329;
  font-weight: 700;
}

.product-detail-wrap .item-info .price {
  font-size: 18px;
  color: #1f2329;
}

.product-detail-wrap .item-info .currencySymbol {
  font-size: 14px;
  color: #1f2329;
}

.product-detail-wrap .item-info .util-del {
  color: #999;
}

.product-detail-wrap .item-info .unit {
  color: #1f2329;
  margin-right: 12px;
  font-size: 14px;
}

.product-detail-wrap .item-info .pq-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}

.product-detail-wrap .item-info .input-numbers {
  vertical-align: middle;
  height: 32px;
  width: 100px;
  font-size: 15px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.product-detail-wrap .item-info .input-numbers .input-default {
  border-left: 0;
  border-right: 0;
  border-color: #e8e8e8;
  font-size: 15px;
}

.product-detail-wrap .item-info .input-number-key-option {
  font-size: 18px;
  border-color: #e8e8e8;
  width: 32px;
  height: 32px;
  background: #f9faff;
  color: rgba(0, 0, 0, 0.65);
  text-align: center;
  line-height: 1;
  padding: 6px 0;
}

.product-detail-wrap .item-info .input-number-cut {
  border-radius: 4px 0 0 4px;
}

.product-detail-wrap .item-info .input-number-add {
  border-radius: 0 4px 4px 0;
}

.product-detail-wrap .item-info .btn-join {
  border: 0;
  margin-left: 10px;
  vertical-align: middle;
  font-size: 16px;
  line-height: 1.5;
  padding: 11px 10px;
  border-radius: 4px;
  min-width: 174px;
}

.product-detail-wrap .item-info .btn-register {
  background: -o-linear-gradient(177.47deg, #1477ff 2.87%, #57aeff 97.2%);
  background: linear-gradient(272.53deg, #1477ff 2.87%, #57aeff 97.2%);
  color: #fff;
}

.product-detail-wrap .item-info .btn-login,
.product-detail-wrap .item-info .btn-register {
  border: 0;
  font-size: 16px;
  line-height: 1.5;
  padding: 11px 10px;
  border-radius: 4px;
  min-width: 80px;
  font-weight: 700;
}

.product-detail-wrap .item-info .btn-login {
  border: 0;
  color: #1477ff;
}

.product-detail-wrap .item-info .btn-join .iconfont {
  font-size: 16px;
}

.product-detail-wrap .item-info .table-content-wrap {
  padding: 17px 0;
  font-size: 16px;
  line-height: 24px;
}

.product-detail-wrap .item-info .table-content-wrap li {
  float: left;
  width: 28%;
  padding: 0 12px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin-top: -5px;
  margin-bottom: -5px;
}

.product-detail-wrap .item-info .table-content-wrap li:nth-child(2) {
  width: 34%;
  border-left: 1px solid #f0f0f0;
  border-right: 1px solid #f0f0f0;
}

.product-detail-wrap .item-info .table-content-wrap li:last-child {
  width: 38%;
}

.product-detail-wrap .item-info .table-content-tit {
  font-size: 14px;
  line-height: 22px;
  color: #939aa3;
}

.product-detail-wrap .item-info .table-content-word {
  color: #646a73;
}

.product-detail-wrap .item-info .table-content-word .gray {
  color: #939aa3;
}

.product-detail-wrap .item-info .choose-style a {
  display: inline-block;
  margin-right: 13px;
  margin-bottom: 5px;
  cursor: pointer;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
}

.product-detail-wrap .item-info .choose-style .active,
.product-detail-wrap .item-info .choose-style a:hover {
  border: 1px solid #1477ff;
}

.product-detail-wrap .item-info .choose-style .img {
  width: 85px;
  height: 85px;
  display: block;
}

.product-detail-wrap .item-info .choose-style.choose-style-lage .img {
  width: 106px;
  height: 106px;
}

.product-detail-wrap .item-info .choose-style-content {
  width: 100%;
  margin-right: -13px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.product-detail-wrap .item-info .util-underline {
  text-decoration: underline;
}

.product-detail-wrap .item-info .item-info-flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.product-detail-wrap .item-info .item-info-left {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100px;
  flex: 0 0 100px;
  color: #1f2329;
}

.product-detail-wrap .one-box-wrap {
  padding: 0 17px;
  height: 52px;
  /* background: url(../picture/7d578533-d198-40bf-99cf-2166e04de850.jpg) no-repeat; */
  background-size: 100% auto;
  margin-bottom: 8px;
  color: #fff;
  font-weight: 700;
  font-size: 16px;
}

.product-detail-wrap .one-box-wrap .content {
  color: #fff;
  line-height: 52px;
}

.product-detail-wrap .one-box-wrap .clock-bg {
  text-align: center;
  width: 28px;
  height: 28px;
  background: rgba(0, 0, 0, 0.45);
  border-radius: 2px;
  display: inline-block;
  line-height: 28px;
  color: #fff;
}

.product-detail-wrap .brand-qualifications .item-info-flex {
  margin-bottom: 12px;
}

.product-detail-wrap .brand-qualifications .item-info-right {
  font-size: 14px;
  line-height: 22px;
}

.product-detail-wrap .brand-qualifications .a-link {
  font-size: 14px;
  color: #00b2ff;
}

.product-detail-wrap .brand-qualifications-info > span {
  padding: 0 12px;
  border-right: 1px solid #f0f0f0;
}

.product-detail-wrap .brand-qualifications-info > span:first-child {
  padding-left: 0;
}

.product-detail-wrap .brand-qualifications-info > span:last-child {
  padding-right: 0;
}

.product-detail-wrap .brand-qualifications-info .num {
  color: #1f2329;
  margin-right: 5px;
}

.product-detail-wrap .product-brand-info {
  position: absolute;
  top: 0;
  right: 10px;
  z-index: 3;
  width: 745px;
}

.product-detail-wrap .product-brand-info .brand-tag {
  position: absolute;
  top: -29px;
  right: 10px;
  z-index: 1;
  padding: 0 35px 0 50px;
  /* background: url(../img/product/brand.png) no-repeat; */
  min-width: 168px;
  max-width: 230px;
  height: 48px;
  background-size: 100% 100%;
}

.product-detail-wrap .product-brand-info .icon-qitawanjux {
  position: absolute;
  right: 5px;
  top: 0;
  color: #333;
  font-size: 30px;
}

.product-detail-wrap .product-brand-info .brand-name {
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 2.8rem;
}

.product-detail-wrap .product-brand-info .brand-name em {
  position: relative;
  font-style: normal;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.product-detail-wrap .product-brand-info .brand-icon {
  position: absolute;
  top: 7px;
  left: 15px;
  width: 26px;
  height: 26px;
}

.product-detail-wrap .product-brand-info .content {
  width: 475px;
}

.product-detail-wrap .product-brand-info .brand-info-panel {
  display: none;
  background: #fff;
  -webkit-box-shadow: -2px 5px 12px rgba(72, 72, 72, 0.13);
  box-shadow: -2px 5px 12px rgba(72, 72, 72, 0.13);
  padding: 20px;
}

.product-detail-wrap .product-brand-info .brand-info-panel.animated {
  -webkit-animation-duration: 0.2s;
  animation-duration: 0.2s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.product-detail-wrap .product-brand-info .title {
  font-size: 16px;
  border-bottom: 1px solid #eaeaea;
  font-weight: 700;
  padding: 5px 0;
}

.product-detail-wrap .product-brand-info .main-info {
  width: 100%;
}

.product-detail-wrap .product-brand-info .main-info td {
  border-bottom: 1px solid #eaeaea;
  height: 40px;
  vertical-align: middle;
  padding: 0 5px;
}

.product-detail-wrap .product-brand-info .main-info tr td:first-child {
  white-space: nowrap;
  width: 75px;
}

.product-detail-wrap .product-brand-info .main-info tr:last-child td {
  border-bottom: none;
}

.product-detail-wrap .product-brand-info .btn {
  min-width: 160px;
}

.product-detail-wrap .brandNew-isContract {
  border: 1px solid #00b2ff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 8px;
  background: -o-linear-gradient(359.71deg, #f7fcff 0.02%, #f7fcff 99.98%);
  background: linear-gradient(90.29deg, #f7fcff 0.02%, #f7fcff 99.98%);
}

.product-detail-wrap .brand-new-wrap {
  background: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 14px;
}

.product-detail-wrap .brand-new-wrap .isContract-icon {
  position: absolute;
  right: 5px;
  top: 0;
  width: 45px;
  height: 45px;
}

.product-detail-wrap .brand-new-wrap .option-color {
  color: #939aa3;
}

.product-detail-wrap .brand-new-wrap .brand-new-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.product-detail-wrap .brand-new-wrap .brand-new-item:first-child {
  border-right: 1px solid #f0f0f0;
  padding-right: 15px;
  width: 55%;
}

.product-detail-wrap .brand-new-wrap .brand-new-item:last-child {
  padding-left: 15px;
  width: 45%;
}

.product-detail-wrap .brand-new-wrap .brand-img-wrap {
  width: 72px;
  height: 72px;
}

.product-detail-wrap .brand-new-wrap .brand-img-wrap img {
  max-width: 72px;
}

.product-detail-wrap .brand-new-wrap .brand-left-info {
  margin-left: 15px;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.product-detail-wrap .brand-new-wrap .brand-title {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.product-detail-wrap .brand-new-wrap .brand-name {
  color: #1f2329;
  font-weight: 700;
  font-size: 18px;
}

.product-detail-wrap .brand-new-wrap .year-icon {
  color: #1f2329;
  background: #f0eeed;
  border-radius: 39px;
  padding: 0 8px;
}

.product-detail-wrap .brand-new-wrap .year-icon .iconfont {
  font-size: 12px;
}

.product-detail-wrap .brand-new-wrap .year-icon-num {
  font-family: roboto;
  font-weight: 700;
  margin-right: 2px;
}

.product-detail-wrap .brand-new-wrap .certify-icon {
  width: 24px;
  height: 24px;
}

.product-detail-wrap .brand-new-wrap .brand-left-bottom .info-item {
  display: inline-block;
  padding: 0 8px;
}

.product-detail-wrap .brand-new-wrap .brand-left-bottom .info-item:first-child {
  border-right: 1px solid #f0f0f0;
}

.product-detail-wrap .brand-new-wrap .brand-left-bottom .info-item-value {
  color: #000;
  margin-left: 8px;
}

.product-detail-wrap .brand-new-wrap .brand-btn-wrap,
.product-detail-wrap .brand-new-wrap .brand-left-bottom-info {
  display: inline-block;
}

.product-detail-wrap .brand-new-wrap .brand-btn-wrap .btn {
  padding: 0 15px;
  border-radius: 4px;
  font-size: 14px;
  height: 32px;
  line-height: 32px;
}

.product-detail-wrap .brand-new-wrap .brand-btn-wrap .btn .iconfont {
  font-size: 14px;
}

.product-detail-wrap .brand-new-wrap .brand-index-btn {
  color: #00b2ff;
  background: #f1f9ff;
}

.product-detail-wrap .brand-new-wrap .brand-like-btn {
  color: #646a73;
}

.product-detail-wrap .brand-new-wrap .brand-new-item-right {
  width: 50%;
}

.product-detail-wrap .brand-new-wrap .brand-new-item-right-value {
  white-space: nowrap;
  width: 100%;
}

.product-detail-wrap .base-info .special-attr li,
.product-detail-wrap .item-info .special-attr li {
  display: inline-block;
  vertical-align: top;
}

.product-detail-wrap .item-info {
  font-size: 12px;
  line-height: 20px;
  color: #939aa3;
}

.product-detail-wrap .item-info .special-attr li {
  width: 50%;
  margin-top: 5px;
}

.product-detail-wrap .base-info .color-little-gray {
  color: #999;
}

.product-detail-wrap .base-info .special-attr li {
  width: 33%;
  margin-bottom: 10px;
  height: 30px;
}

.product-detail-wrap .item-info .attr-line {
  border-top: 1px solid #ebebeb;
  padding-top: 12px;
}

.product-detail-wrap .base-info .title {
  border-bottom: 1px solid #f4f6f9;
  padding-bottom: 10px;
  line-height: 18px;
}

.product-detail-wrap .base-info .title .sub-title {
  font-size: 15px;
  line-height: 35px;
  font-weight: 600;
  border-bottom: 1px solid #f4f6f9;
}

.product-detail-wrap .base-info .special-attr {
  min-height: 82px;
}

.product-detail-wrap .description .fixed-style {
  position: fixed;
  top: 0;
  width: 1205px;
  z-index: 1;
}

.product-detail-wrap .description .title-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-bottom: 8px;
  font-size: 18px;
  color: #1f2329;
}

.product-detail-wrap .description .title-border {
  background: #1477ff;
  display: inline-block;
  width: 3px;
  height: 16px;
  margin-right: 8px;
}

.product-detail-wrap .description .tab {
  background: #fafcff;
}

.product-detail-wrap .description .tab li {
  float: left;
}

.product-detail-wrap .description .tab .item {
  padding: 14px 24px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  color: inherit;
  display: inline-block;
}

.product-detail-wrap .description .tab .item.active {
  background: #fff;
  border-top: 2px solid #1477ff;
  color: #1477ff;
}

.product-detail-wrap .description .desc {
  padding: 10px 20px;
}

.product-detail-wrap .description .desc .certificate {
  padding: 10px 0;
}

.product-detail-wrap .description .desc .certificate .item {
  float: left;
  margin-right: 10px;
}

.product-detail-wrap .description .desc .certificate img {
  width: auto;
  height: 40px;
}

.product-detail-wrap .description .desc .info {
  text-align: center;
}

.product-detail-wrap .description .inquiry {
  padding: 20px;
  font-size: 14px;
  min-height: 127px;
}

.product-detail-wrap .description .inquiry dl {
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f4f6f9;
}

.product-detail-wrap .description .inquiry dl:last-child {
  margin: 0;
  padding: 0;
  border: 0;
}

.product-detail-wrap .description .inquiry dt {
  color: #222;
  font-weight: 600;
}

.product-detail-wrap .description .inquiry dd {
  margin-top: 6px;
  color: #666;
}

.product-detail-wrap .description .record {
  padding: 20px;
  font-size: 14px;
  min-height: 127px;
}

.product-detail-wrap .description .record table {
  margin-bottom: 20px;
  width: 100%;
}

.product-detail-wrap .description .record table th {
  padding: 6px 8px;
  background: #efefef;
  text-align: left;
}

.product-detail-wrap .description .record table td {
  padding: 6px 8px;
  border-bottom: 1px solid #f5f5f5;
}

.product-detail-wrap .description .record table .country {
  vertical-align: middle;
  margin-right: 5px;
}

.product-detail-wrap .description .record .loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.07);
}

.product-detail-wrap .description .record .loading .icon-loading {
  width: 100%;
  height: 100%;
  /* background: url(/assets/img/base/ld-16a.gif) center center no-repeat; */
}

.product-detail-wrap .attr-content .player {
  padding: 0 0 30px;
}

.product-detail-wrap .attr-content .player video {
  display: block;
  margin: 0 auto;
  width: 800px;
  height: 452px;
}

.product-detail-wrap .attr-content .player iframe {
  clear: both;
  display: block;
  margin: auto;
  width: 800px;
  height: 452px;
  border: 0;
}

.product-detail-wrap .attr-content .image img {
  display: block;
  margin: 0 auto;
  max-width: 100%;
}

.product-detail-wrap .recommend .pd-switch-grid li {
  padding-bottom: 10px;
}

.product-detail-wrap .recommend .title {
  font-size: 18px;
  margin-bottom: 15px;
}

.product-detail-wrap .recommend .search-camera {
  padding-top: 20px;
  text-align: center;
}

.product-detail-wrap .recommend .search-camera .box {
  display: inline-block;
  padding: 5px 15px;
  color: #4a90e2;
  border: 1px solid #4a90e2;
  border-radius: 3px;
  font-size: 15px;
  cursor: pointer;
}

.product-detail-wrap .bottom,
.product-detail-wrap .bottom .a-link {
  font-size: 14px;
}

.product-detail-wrap .bottom .title {
  font-size: 18px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.product-detail-wrap .brand-mini-wrap {
  display: none;
  position: absolute;
  top: 0;
  right: -240px;
  width: 230px;
  background: #fff;
  padding: 10px;
  font-size: 14px;
  border-radius: 4px;
}

.product-detail-wrap .brand-mini-wrap .brand-name {
  color: #000;
  font-weight: 700;
}

.product-detail-wrap .brand-mini-wrap .info-item-option {
  color: #939aa3;
}

.product-detail-wrap .brand-mini-wrap .brand-btn-wrap .btn {
  border: 1px solid #f0f0f0;
  color: #646a73;
  padding: 0 5px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  margin-top: 5px;
}

.product-detail-wrap .brand-mini-wrap .brand-btn-wrap .btn .iconfont {
  font-size: 14px;
}

.product-detail-wrap .brand-mini-wrap .link-btn {
  color: #00b2ff;
}

.product-detail-wrap .product-right-tool-wrap {
  position: absolute;
  right: -45px;
  top: 0;
  width: 40px;
  z-index: 130;
}

.product-detail-wrap .product-right-tool-content {
  position: fixed;
  top: 210px;
  display: block;
  width: 40px;
  height: 90px;
  z-index: 1;
}

.product-detail-wrap .product-right-tool-content ul {
  background: rgba(31, 35, 41, 0.7);
  border-radius: 4px;
}

.product-detail-wrap .product-right-tool-content ul .product-right-tool-item {
  text-align: center;
}

.product-detail-wrap
  .product-right-tool-content
  ul
  .product-right-tool-item:last-child
  a {
  border-bottom: none;
}

.product-detail-wrap .product-right-tool-content ul .item-btn {
  color: #fff;
  display: inline-block;
  width: 100%;
  cursor: pointer;
  position: relative;
  padding: 0 8px;
}

.product-detail-wrap .product-right-tool-content ul .item-btn .iconfont {
  font-size: 18px;
}

.product-detail-wrap .product-right-tool-content ul .item-btn-content {
  display: inline-block;
  width: 100%;
  padding: 9px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
}

#upDown {
  top: 410px !important;
}

@media (min-width: 1685px) {
  .product-detail-wrap .brand-mini-wrap {
    display: block;
  }

  .product-detail-wrap .product-right-tool-content {
    top: 360px;
  }

  #upDown {
    top: 550px !important;
  }
}

.custom-popover {
  width: 130px;
  position: absolute;
  right: 35px;
  top: 0;
  color: rgba(0, 0, 0, 0.65);
  display: none;
}

.custom-popover .custom-popover-inner {
  -webkit-box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  box-shadow: 0 3px 6px -4px rgba(0, 0, 0, 0.12),
    0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
  background: #fff;
}

.custom-popover .custom-popover-inner-content {
  padding: 10px;
}

.custom-popover .custom-popover-inner-content .qr-code-img {
  max-width: 100%;
}

.custom-popover .icon-arrow-blue-r {
  position: absolute;
  top: 10px;
  right: 0;
  border-color: #fff #fff transparent transparent;
}

.custom-popover-left {
  padding-right: 10px;
}

#askPricePopover {
  width: 680px;
  height: auto !important;
  font-size: 14px;
}

#askPricePopover .ask-price-tip {
  padding: 5px 10px;
  border-width: 1px;
  border-style: solid;
  line-height: 30px;
}

#askPricePopover table {
  width: 100%;
  table-layout: fixed;
}

#askPricePopover table td:first-child {
  width: 155px;
}

#askPricePopover td {
  padding: 10px 0;
  vertical-align: middle;
}

#askPricePopover .padding-right-20 {
  padding-right: 20px;
}

#askPricePopover .moq-title {
  vertical-align: top;
  line-height: 34px;
}

#askPricePopover .draggable-progress-title {
  padding-top: 15px;
}

.draggable-progress {
  margin-top: 35px;
  padding-bottom: 30px;
}

.draggable-progress .bg {
  position: relative;
  width: 100%;
  height: 3px;
  background: #dedede;
}

.draggable-progress .content {
  height: 3px;
  background: #fd5254;
  width: 0;
  position: relative;
}

.draggable-progress .dot-wrap {
  position: absolute;
  right: -15px;
  bottom: -10px;
  white-space: nowrap;
  z-index: 1;
  text-align: center;
}

.draggable-progress .dot {
  background: #fff;
  width: 30px;
  height: 30px;
  display: block;
  border: 2px solid #999;
  border-radius: 50%;
  cursor: pointer;
}

.draggable-progress .per-key {
  position: absolute;
  margin-top: 10px;
  width: 30px;
  cursor: pointer;
  margin-left: -15px;
}

.draggable-progress .color-key {
  display: block;
  height: 12px;
  width: 3px;
  background: #dedede;
  margin-top: -22px;
  margin-bottom: 10px;
  margin-left: 13px;
  text-align: center;
}

.draggable-progress .color-key.short {
  margin-top: -18px;
  height: 8px;
  width: 1px;
}

.draggable-progress .color-key.strong {
  width: 3px;
  margin-top: -20px;
  height: 10px;
}

.draggable-progress .active .color-key {
  background: #fd5254;
}

.draggable-progress .name {
  width: 30px;
  text-align: center;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductDetail.vue